import React from 'react';
import { useAppState } from '../RetailerFitGuide_StateContext.jsx';
import { track_addToList, track_linkClick } from '../Script/RetailerFitGuide_Tracking.js';
import { TRACK_EVENT_TYPE } from '../Script/RetailerFitGuide_Constants.js';
const RetailerFitGuide_ProductListItem = ({
  productListItem,
  showQuantity,
  removeListProduct,
  showAddToCartButton,
  trackingType,
}) => {
  if (!productListItem) return null;

  const { translations, productList, setProductList, setNotificationMessage, selectedSolution } = useAppState();

  const addProductsToList = (productListItem) => {
    let updatedList = [...productList];
    const existing = updatedList.find((x) => x.ProductId === productListItem.ProductId);
    if (existing) existing.Quantity += 1;
    else updatedList.push({ ...productListItem, Quantity: 1 });
    track_addToList([productListItem.ProductId], TRACK_EVENT_TYPE.CARFIT);
    setProductList(updatedList);
    setNotificationMessage(translations.productAddedToList);
  };

  return (
    <li className="retailerFitGuide_ProductListItem">
      <a
        onClick={() => track_linkClick(trackingType)}
        href={productListItem.ProductUrl}
        target="_blank"
        rel="noreferrer"
      >
        <img src={productListItem?.ProductImage?.ImageURL} alt={productListItem?.ProductImage?.ImageAltText} />
        <div className="flex-grow-1 pe-3">
          <h2 className="heading6">{productListItem.WebTitle1}</h2>
          <p className="text-color--gray80 paragraph--s">{productListItem.WebTitle2}</p>
          <p>
            <span className="paragraph--s text-color--gray80">SKU:</span>{' '}
            <span className="heading6 mb-0 retailerFitGuide_highlight">{productListItem.SKU}</span>
          </p>
          {productListItem.adapter && (
            <p className="paragraph--s text-color--gray80">
              {translations.adaptersRequired} {productListItem.adapter.WebTitle1} ({productListItem.adapter.ThuleSKUNo})
            </p>
          )}
          {showQuantity && (
            <p>
              <span className="paragraph--s text-color--gray80">{translations.quantity}:</span>{' '}
              <span className="heading6 mb-0">{productListItem.Quantity}</span>
            </p>
          )}
        </div>
      </a>
      <div className="heading6 d-flex flex-column justify-content-between">
        <>
          <div className="heading6 text-end">
            <div>MSRP</div>
            <div>{productListItem?.TotalLinePriceFormatted}</div>
          </div>
          {showAddToCartButton && (
            <div className="d-flex justify-content-end">
              <button
                onClick={() => addProductsToList(productListItem)}
                className="btn thule-btn-default btn-icon-md mt-4"
              >
                <span className="sr-only">Add to list</span>
                <i className="le-icon-bookmark-plus"></i>
              </button>
            </div>
          )}
          {removeListProduct && (
            <button
              onClick={() => removeListProduct(productListItem.ProductId)}
              className="btn paragraph--xs productList_removeBtn"
            >
              {translations.remove}
            </button>
          )}
        </>
      </div>
    </li>
  );
};
export default RetailerFitGuide_ProductListItem;
